import React, { useState, useEffect } from 'react';
import "./Financials.css";
import * as FeatherIcon from 'react-feather';
import MicroChart from '../../../HtmlElements/MicroChart';

export default function KeyStatistics({records = [], requiredValue}) {

  if (!records || Object.keys(records).length === 0) {
  //  return <div></div>;
  }

  const key_statistics = {
    "IQ_COMMON": "Common Equity",
    "IQ_DILUT_EPS_INCL": "Diluted EPS Excl. Extra Items ($)",
    "IQ_EARNING_CO": "Earnings from Cont. Ops.",
    "IQ_EBIT": "EBIT",
    "IQ_EBITDA": "EBITDA",
    "IQ_GP": "Gross Profit",
    "IQ_CLOSEPRICE*": "Last Close Price",
    "IQ_MARKETCAP*": "Market Capitalization",
    "IQ_NI": "Net Income",
    "IQ_SHARESOUTSTANDING*": "Shares Outstanding",
    "IQ_TOTAL_ASSETS": "Total Assets",
    "IQ_TOTAL_CAP": "Total Capital",
    "IQ_CAPEX": "Total Capital Expenditure",
    "IQ_TOTAL_DEBT": "Total Debt",
    "IQ_DA": "Total Depreciation & Amortization",
    "IQ_TEV": "Total Enterprise Value (TEV)",
    "IQ_TOTAL_LIAB": "Total Liabilities",
    // "" : "Total Operating Profit Before Tax",
    "IQ_TOTAL_REV": "Total Revenue",
  };

  const recordsArray = Array.isArray(records) ? records : [];
  const latestYears = Array.from(
    new Set(recordsArray.flatMap(record => record.data.map(item => item.year)))
  )
    .sort((a, b) => b - a)
    .slice(0, 5)
    .reverse();

  return (
    <>
      {
        <div className="col-md-12 mb-2 mt-2">
          <div className="custom_card_block">
            <div className="quarterly_result_block">
              <div className="head_top">
                <h5 className="main_head">Key Statistics</h5>
                <p className="main_head_para">
                  Figures in $Mn; except EPS
                  {/* / <span className='blue_text'>View Standalone</span> */}
                </p>
              </div>

              <div className="quater_table_block">

                {latestYears.length <= 0 &&
                <div className='row'>
                  <div className='col-md-12'>
                    <div className="alert alert-warning" role="alert">
                    Complete financials are only available in paid version.
                    </div>
                  </div>
                </div>
                }

                {latestYears.length > 0 &&
                <div className="table-responsive custom_table_qut ">
                  <table className="quater_table custom-resizable-table mb-0">
                    <thead className="quater_table_thead">
                      <tr className="quater_table_tr custom-resizable-table-header">
                        {/* <th className="quater_table_th"></th>
                        <th className="quater_table_th">2019</th>
                        <th className="quater_table_th">2020</th>
                        <th className="quater_table_th">2021</th>
                        <th className="quater_table_th">2022</th>
                        <th className="quater_table_th">2023</th>
                        <th className="quater_table_th text-center" style={{width: '110px'}}>5-Year Trend</th> */}
                        <th className="quater_table_th"></th>
                        {latestYears.map(year => (
                          <th key={year} className="quater_table_th"><div className='custom-resizable-table-th-content'>{year}</div></th>
                        ))}
                        <th className="quater_table_th text-center" style={{ width: '110px' }}><div className='custom-resizable-table-th-content'>5-Year Trend</div></th>
                      </tr>
                    </thead>

                    <tbody className="quater_table_tbody">
                      {Object.entries(key_statistics).map(([key, label]) => {
                        const record = records.find(item => item._id === key);
                        if (!record) return null;

                        const yearDataMap = Object.fromEntries(record.data.map(item => [item.year, item.value]));
                        const chartData = latestYears.map(year => ({ category: year, value: parseFloat(yearDataMap[year] || 0) }));

                        return (
                          <tr className="quater_table_tr dimension-row cursor-pointer gtr-row " key={key}>
                            <td className="quater_table_td_left gtr-cell">{label}</td>
                            {latestYears.map(year => (
                              <td key={year} className="quater_table_td gtr-cell">
                                {yearDataMap[year] < 0 ? (
                                  <span style={{ color: "red" }}>{requiredValue(yearDataMap[year])}</span>
                                ) : (
                                  requiredValue(yearDataMap[year])
                                )}
                              </td>
                            ))}
                            <td className="quater_table_td text-center gtr-cell">
                              <MicroChart data={chartData} chartType='bar' />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  
                    {/* <tbody className="quater_table_tbody">
                      {Object.entries(key_statistics).map(([key, value]) => {



                        if(records.some(item => item._id === key)){
                          const parentIndex = records.filter(
                            (item) => item._id === key
                          );
                          

                          

                          const childIndex2019 = parentIndex[0].data.filter(
                            (child) => child.year === "2019"
                          );
                          const childIndex2020 = parentIndex[0].data.filter(
                            (child) => child.year === "2020"
                          );
                          const childIndex2021 = parentIndex[0].data.filter(
                            (child) => child.year === "2021"
                          );
                          const childIndex2022 = parentIndex[0].data.filter(
                            (child) => child.year === "2022"
                          );
                          const childIndex2023 = parentIndex[0].data.filter(
                            (child) => child.year === "2023"
                          );
  
                          const val_2019 = parseInt(childIndex2019[0]?.value);
                          const val_2020 = parseInt(childIndex2020[0]?.value);
                          const val_2021 = parseInt(childIndex2021[0]?.value);
                          const val_2022 = parseInt(childIndex2022[0]?.value);
                          const val_2023 = parseInt(childIndex2023[0]?.value);
  
                          const chartData = [
                            {category: '2019', value: val_2019},
                            {category: '2020', value: val_2020},
                            {category: '2021', value: val_2021},
                            {category: '2022', value: val_2022},
                            {category: '2023', value: val_2023},
                          ];
  
                          return (
                            <tr className="quater_table_tr" key={`key_${key}`}>
                              <td className="quater_table_td_left">{value}</td>
                              <td className="quater_table_td">
                                {key !== "IQ_FILINGDATE_IS" ? (
                                  childIndex2019[0]?.value < 0 ? (
                                    <span style={{ color: "red" }}>
                                      {requiredValue(
                                        childIndex2019[0]?.value,
                                        "",
                                        key
                                      )}
                                    </span>
                                  ) : (
                                    requiredValue(childIndex2019[0]?.value)
                                  )
                                ) : (
                                  new Date(
                                    childIndex2019[0]?.value
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })
                                )}
                              </td>
                              <td className="quater_table_td">
                                {key !== "IQ_FILINGDATE_IS" ? (
                                  childIndex2020[0]?.value < 0 ? (
                                    <span style={{ color: "red" }}>
                                      {requiredValue(
                                        childIndex2020[0]?.value,
                                        "",
                                        key
                                      )}
                                    </span>
                                  ) : (
                                    requiredValue(childIndex2020[0]?.value)
                                  )
                                ) : (
                                  new Date(
                                    childIndex2020[0]?.value
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })
                                )}
                              </td>
                              <td className="quater_table_td">
                                {key !== "IQ_FILINGDATE_IS" ? (
                                  childIndex2021[0]?.value < 0 ? (
                                    <span style={{ color: "red" }}>
                                      {requiredValue(
                                        childIndex2021[0]?.value,
                                        "",
                                        key
                                      )}
                                    </span>
                                  ) : (
                                    requiredValue(childIndex2021[0]?.value)
                                  )
                                ) : (
                                  new Date(
                                    childIndex2021[0]?.value
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })
                                )}
                              </td>
                              <td className="quater_table_td">
                                {key !== "IQ_FILINGDATE_IS" ? (
                                  childIndex2022[0]?.value < 0 ? (
                                    <span style={{ color: "red" }}>
                                      {requiredValue(
                                        childIndex2022[0]?.value,
                                        "",
                                        key
                                      )}
                                    </span>
                                  ) : (
                                    requiredValue(childIndex2022[0]?.value)
                                  )
                                ) : (
                                  new Date(
                                    childIndex2022[0]?.value
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })
                                )}
                              </td>
                              <td className="quater_table_td">
                                {key !== "IQ_FILINGDATE_IS" ? (
                                  childIndex2023[0]?.value < 0 ? (
                                    <span style={{ color: "red" }}>
                                      {requiredValue(
                                        childIndex2023[0]?.value,
                                        "",
                                        key
                                      )}
                                    </span>
                                  ) : (
                                    requiredValue(childIndex2023[0]?.value)
                                  )
                                ) : (
                                  new Date(
                                    childIndex2023[0]?.value
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })
                                )}
                              </td>
                              <td className="quater_table_td">
                              { key !== "IQ_FILINGDATE_IS" ? (<MicroChart data={chartData} chartType = 'bar' />) : "" }
                              </td>
                            </tr>
                          );
                        }

                      })}
                    </tbody> */}
                  </table>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}